import { styled } from 'styled-components';
import { getFontSize } from '../../abstracts';
import { createTransition, dontForwardProps, pxToRem } from '../../util';
import { getTooltipPosition } from './utils';
export const getVariantColor = variant => variant === 'dark' ? 'var(--aui-inverse-surface)' : 'var(--aui-neutral-soft)';
export const TooltipContainer = styled.div.withConfig({
  componentId: "aui__sc-1fiqbdz-0"
})(["position:relative;"]);
export const TooltipLabelElement = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1fiqbdz-1"
})(["position:absolute;z-index:100;", " opacity:", ";overflow-wrap:anywhere;max-width:", ";width:max-content;text-align:center;padding:0.75rem;box-sizing:border-box;background-color:", ";color:", ";border-radius:var(--aui-border-radius-050);font-size:", ";line-height:115%;", ";&::after{content:'';height:0;width:0;position:absolute;border:5px solid transparent;}&.tooltip--top::after{top:100%;left:50%;border-top-color:", ";margin-left:-5px;}&.tooltip--bottom::after{bottom:100%;left:50%;border-bottom-color:", ";margin-left:-5px;}&.tooltip--left::after{top:50%;left:100%;border-left-color:", ";margin-top:-5px;}&.tooltip--right::after{top:50%;right:100%;border-right-color:", ";margin-top:-5px;}&.tooltip--top-start::after{top:100%;right:0%;border-top-color:", ";margin-right:8px;}&.tooltip--top-end::after{top:100%;left:0%;border-top-color:", ";margin-left:8px;}&.tooltip--bottom-start::after{bottom:100%;right:0%;border-bottom-color:", ";margin-right:8px;}&.tooltip--bottom-end::after{bottom:100%;left:0%;border-bottom-color:", ";margin-left:8px;}&.tooltip--left-start::after{bottom:8px;left:100%;border-left-color:", ";}&.tooltip--left-end::after{top:8px;left:100%;border-left-color:", ";}&.tooltip--right-start::after{bottom:8px;right:100%;border-right-color:", ";}&.tooltip--right-end::after{top:8px;right:100%;border-right-color:", ";}"], ({
  $position,
  $targetDimensions,
  $dimensions
}) => getTooltipPosition($position, $targetDimensions, $dimensions), ({
  $dimensions
}) => $dimensions.height || $dimensions.width ? 1 : 0, ({
  $maxWidth,
  $targetDimensions
}) => $maxWidth ? `${pxToRem($maxWidth)}rem` : `${pxToRem($targetDimensions.width)}rem`, ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => $variant === 'dark' ? 'var(--aui-inverse-on-surface)' : 'var(--aui-on-neutral-soft)', getFontSize(1), createTransition({
  properties: ['opacity']
}), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant), ({
  $variant
}) => getVariantColor($variant));